
export const acConfigureNotificationDashboardNavList = [
  {
    id: 'acConfigureNotification',
    text: 'Notification Rules',
    isAccessible: true,
  },
  {
    id: 'acConfigureNotificationHistory',
    text: 'History',
    isAccessible: true,
  },
]

export const acConfigureNotificationPopoverNavList = [
  {
    id: 'summary',
    text: 'Summary',
    isAccessible: true
  },
  {
    id: 'history',
    text: 'History',
    isAccessible: true
  },
]
